export default {
    count_active: 'Activa el teu compte!',
    days: 'dies.',
    expired: 'El teu període de prova ha expirat. Activa el teu compte!',
    you_have: 'Tens ',
    take_session: ' Per reservar la sessió formativa gratuïta.',
    take_now: ' Reserva ara.',
}